import React, { useState, useEffect, Fragment } from "react";
import cloneDeep from "lodash.clonedeep";
import { Input, Row, Col } from 'antd';
import TranslatedText from "translations/TranslatedText";

export default function URLConfig(props) {
  const {
    mediaFiles,
    onChange,
  } = props;
  const [media, setMedia] = useState(mediaFiles)

  const parseUrl = (url: string) => {
    const clonedMedia = cloneDeep(media);
    clonedMedia[0].src = url;
    setMedia(clonedMedia);
  }

  useEffect(() => {
    onChange(media);
  }, [media]);

  return (
    <Fragment>
      <Row type="flex" align="middle">
        <Col span={24}>
          <Input
            onChange={(event: any)=>parseUrl(event.target.value)}
            value={media[0].src}
          />
        </Col>
      </Row>
    </Fragment>
  );
}